module.exports = "pegasus/assets/header-fall-automotive-1.jpg";